import script from "./ImageZoomModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageZoomModal.vue?vue&type=script&setup=true&lang=js"

import "./ImageZoomModal.vue?vue&type=style&index=0&id=94fb3be6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94fb3be6"]])

export default __exports__